import React, { FC, useEffect } from "react"

interface MessageModalProps {
  isOpen: boolean
  message: string
  type?: 'success' | 'error'
  onClose: () => void
  autoClose?: boolean
  autoCloseDelay?: number
}

const MessageModal: FC<MessageModalProps> = ({
  isOpen,
  message,
  type = 'success',
  onClose,
  autoClose = true,
  autoCloseDelay = 3000
}) => {
  useEffect(() => {
    if (isOpen && autoClose) {
      const timer = setTimeout(() => {
        onClose()
      }, autoCloseDelay)
      return () => clearTimeout(timer)
    }
  }, [isOpen, autoClose, autoCloseDelay, onClose])

  if (!isOpen) return null

  const bgColor = type === 'success' ? 'bg-green-50 border-green-200' : 'bg-red-50 border-red-200'
  const textColor = type === 'success' ? 'text-green-800' : 'text-red-800'
  const iconColor = type === 'success' ? 'text-green-500' : 'text-red-500'

  return (
    <div className="fixed inset-0 z-[9999] flex items-center justify-center">
      <div className="absolute inset-0 bg-black/50 backdrop-blur-sm" onClick={onClose}></div>
      <div className={`relative bg-white rounded-xl shadow-lg max-w-md w-[90%] p-6 animate-[modalSlideIn_0.3s_ease] ${bgColor} border-2`}>
        <div className="flex items-start gap-4">
          {type === 'success' ? (
            <svg className={`w-6 h-6 ${iconColor} flex-shrink-0 mt-0.5`} fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z"></path>
            </svg>
          ) : (
            <svg className={`w-6 h-6 ${iconColor} flex-shrink-0 mt-0.5`} fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M12 8v4m0 4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z"></path>
            </svg>
          )}
          <div className="flex-1">
            <p className={`text-sm font-medium ${textColor} whitespace-pre-line`}>{message}</p>
          </div>
          <button
            className="bg-transparent border-none cursor-pointer text-gray-400 hover:text-gray-900 transition-colors p-1"
            onClick={onClose}
          >
            <svg width="20" height="20" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M6 18L18 6M6 6l12 12"></path>
            </svg>
          </button>
        </div>
      </div>
    </div>
  )
}

export default MessageModal

